import { getTokenJWT } from "../../utils";
import ErrorToast from "../../../components/errortoast/ErrorToast";

const addCA = {
  //Upload image to media library
  async addImage(data, imgData) {
    let imageId;
    let formData = new FormData();
    formData.append("files", imgData);

    const requestOptions = {
      method: "POST",
      headers: {
        "Authorization": getTokenJWT(),
      },
      body: formData,
      redirect: "follow",
    };

    let newData;
    try {
      const response = await fetch(`${window.$apiUrl}/upload`, requestOptions);
      const res = await response.json();

      imageId = res[0]._id;
      newData = await this.addCA(data, imageId).then((result) => {
        return result;
      });
    } catch(error) {
      console.error(" Error uploading image -->", error)
    }

    return newData;
  },

  //Post content to database
  addCA(data, imageId) {
    //Headers
    let headers = new Headers();
    headers.append("Content-Type", "application/x-www-form-urlencoded");
    headers.append("Authorization", getTokenJWT())

    //Body
    let urlencoded = new URLSearchParams();
    urlencoded.append("rowId", JSON.stringify(data.tableData));
    urlencoded.append("id", JSON.stringify(data.id));
    urlencoded.append("date", data.date);
    urlencoded.append("communicationType", data.communicationType);
    urlencoded.append("title", data.title);
    urlencoded.append("objective", data.objective);
    urlencoded.append("reachedAudience", data.reachedAudience);
    urlencoded.append("link", data.link);
    urlencoded.append("photo", imageId);

    for (let i = 0; i < data.partners.length; i++) {
      urlencoded.append("partners", data.partners[i]);
    }

    for (let j = 0; j < data.targetAudience.length; j++) {
      urlencoded.append("targetAudience", data.targetAudience[j]);
    }

    const requestOptions = {
      method: "POST",
      headers: headers,
      body: urlencoded,
      redirect: "follow",
    };

    return fetch(`${window.$apiUrl}/communications`, requestOptions)
      .then((response) => { return response.json() })
      .then((result) => {
        if (result.statusCode && result.error) {
          console.error(" Error adding communication activity -->", result);
          ErrorToast(result.error);
          return;
        } else return result;
      })
      .catch((error) => console.error(" Error adding communication activity -->", error));
  },
};

export default addCA;
